import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateApplicationInBranchComponent } from '@shared/components/create-application-in-branch/create-application-in-branch.component';
import { UserManagementStateService } from 'app/modules/setup/user-management/user-management.state.service';
import { Subject } from 'rxjs';
import { AuthService } from './auth';

@Injectable({
  providedIn: 'root'
})
export class ApplicationDialogService {
  private dialogOpenSubject = new Subject<void>();
  public dialogOpen$ = this.dialogOpenSubject.asObservable();

  constructor(private dialog: MatDialog,private userService: UserManagementStateService,private auth: AuthService ) {}


  openCreateApplicationDialog(): void {
             this.userService.getUserById(this.auth.userId);
    const dialogRef = this.dialog.open(CreateApplicationInBranchComponent, {
      width: '500px',
      disableClose: false
    });

    dialogRef.afterClosed().subscribe(branchId => {
      if (branchId) {
        console.log('Application started with branch ID:', branchId);
      }
    });
  }
}
